<template>
  <div id="sidebar" class="pt-20 pr-8 flex flex-col">
    <div class="flex mb-8">
      <div class="search-input w-full">
        <input
          class="text-input icon-left placeholder-gray-500 placeholder-opacity-50"
          type="text"
          v-model="query"
          placeholder="Search..."
          @blur="$bus.$emit('section')"
        />
        <button class="search-close" @click="closeSearch">
          <svg fill="white" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 512 512">
            <path
              d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
            ></path>
          </svg>
        </button>
      </div>
    </div>
    <div class="flex flex-grow">
      <div class="flex-grow">
        <categories id="catgeories" class="mb-16"></categories>
        <filters></filters>
      </div>
      <div class="socials">
        <div class="flex justify-between gap-2 text-3xl mb-3 justify-end">
          <a target="_blank" class="social" @click="goTo('https://www.instagram.com/designmorphine/')">
            <font-awesome-icon :icon="['fab', 'instagram']" />
          </a>
          <a target="_blank" class="social" @click="goTo('https://www.linkedin.com/company/designmorphine/')">
            <font-awesome-icon :icon="['fab', 'linkedin']" />
          </a>
          <a target="_blank" class="social" @click="goTo('https://twitter.com/design_morphine')">
            <font-awesome-icon :icon="['fab', 'square-x-twitter']" />
          </a>
          <a target="_blank" class="social" @click="goTo('https://www.youtube.com/DesignMorphine')">
            <font-awesome-icon :icon="['fab', 'youtube-square']" />
          </a>
        </div>
        <div class="flex gap-2 mb-3">
          <button class="bg-white-25 hover:bg-dm py-2 px-3 rounded-full text-center" @click="$modal.show('contact')">
            Contact
          </button>
          <button
            class="w-full bg-white-25 hover:bg-dm py-2 px-3 rounded-full text-center"
            @click="$modal.show('subscribe')"
          >
            Subscribe
          </button>
        </div>
        <button
          v-if="getSettingValueByKey('custom_button_text')"
          class="bg-white-25 hover:bg-dm w-full py-2 px-3 rounded-full mb-3 text-center"
          @click="goTo(getSettingValueByKey('custom_button_url'))"
        >
          {{ getSettingValueByKey('custom_button_text') }}
        </button>
        <button
          class="bg-toggle bg-white-25 hover:bg-dm w-full py-2 px-3 rounded-full flex flex-row items-center mb-3"
          @click="toggleVideo"
        >
          <span class="bg-toggle-link-text">Background </span>
          <span :class="{ 'bg-toggle-link': true, active: background }">{{ background ? 'ON' : 'OFF' }}</span>
        </button>
        <div class="flex justify-between privacy-links mb-4">
          <a class="hover:text-dm" href="/terms" target="_blank">Terms</a>
          <a class="hover:text-dm" href="/privacy" target="_blank">Privacy</a>
          <a class="hover:text-dm" href="/refund" target="_blank">Refund</a>
        </div>
      </div>
    </div>

    <div class="my-5 cursor-pointer" @click="$router.push('/')">
      <div class="logo-container" @mouseover="logoHover = true" @mouseleave="logoHover = false">
        <img id="logo" :src="`/img/LogoText${logoHover === true ? '-Colored' : ''}.svg`" alt="Designmorphine Logo" />

        <span class="copyright-notice">&copy; DesignMorphine {{ currentYear }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Login from './Login';
import Menu from '@components/Menu';
import Filters from '@components/Filters';
import DMModal from '@components/DMModal';

export default {
  name: 'Sidebar',
  components: {
    DMModal,
    login: Login,
    categories: Menu,
    filters: Filters,
  },
  data() {
    return {
      background: true,
      subscribe: {},
      query: '',
      sending: false,
      logoHover: false,
      isLoading: true,
      previousRoute: null,
      settings: [],
      defaultSettingValues: {
        custom_button_text: '',
        custom_button_url: '',
      },
    };
  },
  mounted() {
    this.vid = document.getElementById('bg-vid');
    this.getSettings();
  },

  watch: {
    query: function (val) {
      this.$bus.$emit('search-query', val);
      if (val.length > 0 && this.$route.name !== 'search') {
        this.previousRoute = this.$route;
        this.$router.push({ name: 'search', params: { query: val } });
      }
    },
  },

  methods: {
    toggleVideo() {
      if (this.background === true) {
        this.vid.pause();
      } else {
        this.vid.play();
      }
      this.background = !this.background;
    },

    getSettingValueByKey(key) {
      const setting = this.settings.find((setting) => setting.key === key);

      if (!setting) {
        return this.defaultSettingValues[key];
      }

      return setting.value;
    },

    closeSearch() {
      this.query = '';
      if (this.previousRoute) {
        this.$router.replace({
          name: this.previousRoute.name,
          params: this.previousRoute.params,
          query: this.previousRoute.query,
        });

        this.previousRoute = null;
      }
    },

    getSettings() {
      this.isLoading = true;

      axios
        .get(`/api/settings`)
        .then((response) => {
          this.settings = response.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },

  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped lang="scss">
#sidebar {
  width: 100%;
  height: 100%;

  @media screen and (max-width: 500px) {
    #catgeories {
      margin-bottom: 2rem !important;
    }
  }

  .search-input {
    position: relative;
    &:before {
      content: '';
      width: 20px;
      height: 20px;
      top: 50%;
      left: 20px;
      transform: translate(-50%, -50%);
      display: block;
      position: absolute;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 19.84 19.84'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M12.06,14.32A7.8,7.8,0,1,1,15.58,7.5a7.66,7.66,0,0,1-1,4.11c-.08.15-.16.29-.25.43a.84.84,0,0,0,0,.93,2.15,2.15,0,0,0,.32.35L16,14.7l2.89,2.89.37.36.35.36a.93.93,0,0,1,.16,1,.94.94,0,0,1-1.3.44,1.94,1.94,0,0,1-.37-.33l-2.9-2.89c-.48-.49-1-1-1.45-1.45l-.36-.36a4,4,0,0,0-.36-.35A.86.86,0,0,0,12.06,14.32ZM13.75,7.8a6,6,0,1,0-5.95,6A6,6,0,0,0,13.75,7.8Z'/%3E%3C/svg%3E");
    }
  }

  .search-close {
    width: 20px;
    height: 20px;
    top: -1px;
    right: 20px;
    transform: translate(50%, 50%);
    display: block;
    position: absolute;
    z-index: 2;
  }

  button {
    font-size: 0.875rem;
    font-weight: 300;
  }

  .socials .social {
    cursor: pointer;

    &:hover {
      @apply text-dm;
    }

    img {
      height: 25px;
    }
  }

  .privacy-links {
    color: #414141;
    font-size: 14px;
    font-weight: 500;
  }

  .logo-container {
    position: relative;

    .copyright-notice {
      position: absolute;
      right: 0;
      bottom: 2px;
      color: #414141;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .bg-toggle {
    position: relative;
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 0.25rem;

    .link {
      position: absolute;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.145);
    }
  }

  .bg-toggle:hover {
    .bg-toggle-link {
      background: #f0284b;
    }
  }

  .bg-toggle-link-text {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .bg-toggle-link {
    @apply rounded-full;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-left: auto;
    margin-right: 0px;
    border: 1px solid white;
    padding: 0.25rem 0.5rem;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    width: 68px;

    &.router-link-exact-active,
    &.active,
    &:hover {
      &::after {
        @apply bg-dm;
      }
    }

    &.active {
      &::after {
        transform: translateX(-7px);
      }
    }

    &::after {
      transition: transform 0.25s;
      margin-left: 10px;
      display: inline-block;
      content: '';
      width: 15px;
      height: 15px;
      @apply rounded-full;
      border: 2px solid white;
    }
  }
}
</style>
